export default "__VITE_ASSET__DPjC8Wzd__"